module.exports = __webpack_public_path__ + "static/media/parcel-hover.5eee04ed.svg";